import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { ExternalExamGroup } from '../../../../../api/types/external-exams/external-exam-group';
import { deleteExternalExamGroupOperation } from '../operations/delete-external-exam-group-operation';

interface DeleteGroupConfirmDialogProps {
  group: ExternalExamGroup | null;
  visible: boolean;
  onHide: () => void;
}

export const DeleteGroupConfirmDialog: React.FC<
  DeleteGroupConfirmDialogProps
> = ({ group, visible, onHide }) => {
  const [loading, setLoading] = useState(false);
  const [deleteGroupId, setDeleteGroupId] = useState<number | null>(null);

  const handleDelete = async () => {
    if (!group) return;
    setLoading(true);
    await deleteExternalExamGroupOperation(group.id, setDeleteGroupId);
    setLoading(false);
    onHide();
  };

  return (
    <Dialog
      header="אישור מחיקת מקבץ"
      visible={visible}
      onHide={onHide}
      style={{
        width: '450px',
        backgroundColor: 'white',
        padding: '8px',
        borderRadius: '8px',
      }}
      modal
      closable={!loading}
    >
      <div style={{ direction: 'rtl', padding: '8px', textAlign: 'center' }}>
        <i
          className="pi pi-exclamation-triangle"
          style={{
            fontSize: '3rem',
            color: '#f59e0b',
            marginBottom: '16px',
          }}
        />
        <p style={{ fontSize: '16px', fontWeight: 500, marginBottom: '8px' }}>
          האם אתה בטוח שברצונך למחוק את המקבץ?
        </p>
        {group && (
          <p
            style={{
              fontSize: '18px',
              fontWeight: 600,
              color: '#1f2937',
              marginBottom: '12px',
            }}
          >
            "{group.groupName}"
          </p>
        )}
        {group && group.exams.length > 0 && (
          <p
            style={{
              fontSize: '14px',
              color: '#dc2626',
              marginBottom: '16px',
            }}
          >
            <i className="pi pi-info-circle" style={{ marginLeft: '4px' }} />
            מקבץ זה מכיל {group.exams.length} מבחנים שיימחקו גם כן
          </p>
        )}
        <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '24px' }}>
          פעולה זו אינה ניתנת לביטול
        </p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <Button
            label="ביטול"
            severity="secondary"
            onClick={onHide}
            disabled={loading}
          />
          <Button
            label="מחק"
            severity="danger"
            onClick={handleDelete}
            loading={loading || deleteGroupId !== null}
          />
        </div>
      </div>
    </Dialog>
  );
};
